


































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import { SelectItem, SelectItemString } from "@/types";
import NumberInput from "@/components/common/NumberInput.vue";
import CountTextArea from "@/components/common/CountTextArea.vue";

@Component({
  components: { NumberInput, CountTextArea }
})
export default class OtherMedical4 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() reduction_unit_items!: SelectItem[]; //減額単位アイテムリスト
  @Prop() exemption_category_codes!: SelectItem[]; //減免区分コード
  @Prop() customer_amount_codes!: SelectItemString[]; //窓口負担額区分コード

  /**
   * 第二公費の公費給付対象一部負担金を未記載（空白）にするか
   *
   * この画面は合計請求額・給付対象額を編集でき、療養費明細の変更でも
   * total_invoice1〜3 が再計算されるため、編集中の値から都度判定する。
   * 判定条件はバックエンドの model.ShouldOmitReductionPublic2 と同じ。
   * https://ewell-ibow.backlog.com/view/IV2-4781
   */
  private get isOmitReductionPublic2(): boolean {
    // 値が無い(null)／0 以外は常にそのまま（手入力値を最優先）
    if (this.tab.reduction_public2 !== 0) {
      return false;
    }
    // 「保険請求額 ＝ 第一公費請求額 ＝ 第二公費請求額」のときだけ対象
    if (
      this.tab.total_invoice1 !== this.tab.total_invoice2 ||
      this.tab.total_invoice1 !== this.tab.total_invoice3
    ) {
      return false;
    }
    // 1:社保 / 3:公費単独 → 支払基金提出。設定によらず常に未記載
    if (this.tab.ins_type === 1 || this.tab.ins_type === 3) {
      return true;
    }
    // 2:国保 / 4:後期 / 5:退職者 → 国保連提出。設定に従う
    return this.tab.omit_kokuho_reduction2;
  }
}
